import BaseClient from './BaseClient';

class GroupCollectionsClient extends BaseClient {
    listGroupCollections(teamId) {
        const url = `/api/v3/teams/${teamId}/group-collections`;
        return this.makeCoreApiRequest(url, 'get');
    }

    showGroupCollection(teamId, groupCollectionId) {
        const url = `/api/v3/teams/${teamId}/group-collections/${groupCollectionId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createGroupCollection(teamId, data) {
        const url = `/api/v3/teams/${teamId}/group-collections`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateGroupCollection(teamId, groupCollectionId, data) {
        const url = `/api/v3/teams/${teamId}/group-collections/${groupCollectionId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteGroupCollection(teamId, groupCollectionId) {
        const url = `/api/v3/teams/${teamId}/group-collections/${groupCollectionId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getGroupCollectionsGroupCounts(teamId, params) {
        const method = 'get';
        const url = `/api/v3/teams/${teamId}/group-collections/group-counts`;

        return this.makeCoreApiRequest(url, method, null, params);
    }
}

export default new GroupCollectionsClient();
